import { canv } from '@/canv/global.js'
import {setClick, getTarget, sleep, MakeRequest} from '@/canv/utils.js';

export class passwordWindow {

    constructor() {

    }

    async open(success) {
        this.success = success;

        const passwordWindowWrapper = document.createElement('div');
        passwordWindowWrapper.classList.add("passwordWindowWrapper");
        document.body.prepend(passwordWindowWrapper);

        passwordWindowWrapper.innerHTML += this.getTemplate();

        this.init();
    }

    close() {
        let passwordWindowWrapper = document.getElementsByClassName("passwordWindowWrapper")[0];
        if (passwordWindowWrapper !== undefined) {
            passwordWindowWrapper.outerHTML = "";
        }
    }



    init() {
        setClick("passwordWindowPassAction", this.actionClick.bind(this));

        let passInput = document.getElementsByClassName("passwordWindowPassFieldInput")[0];
        passInput.addEventListener('keypress', this.fieldInput.bind(this), false);
    }

    // Proccessors

    fieldInput(e) {
        if (e.key === 'Enter') {
            this.actionClick();
        }
    }

    async actionClick() {
        let passField = document.getElementsByClassName("passwordWindowPassFieldInput")[0];

        if (passField.value === "") {
            canv.appInterface.infoWindow.open("Введите пароль");
            return;
        }

        let passToToken = await MakeRequest("/api/v2/board/share/link/access/password/apply", {
            "token": canv.getInitDataProp("userToken"),
            "boardUID": canv.getInitDataProp("boardUID"),
            "password": passField.value
        });

        if (passToToken["status"] !== "success") {
            canv.appInterface.infoWindow.open("Неверный пароль");
            return;
        }

        this.close();
        this.success(passToToken["boardAccessToken"]);
    }



    // Templates

    getTemplate() {

        return `
            <div class="passwordWindow">
                <div class="passwordWindowInfo">Введите пароль,<br>чтобы открыть эту доску</div>
                <div class="passwordWindowPass">
                    <div class="passwordWindowPassField">
                        <input type="password" class="passwordWindowPassFieldInput" placeholder="Введите пароль">
                    </div>
                    <div class="passwordWindowPassAction">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="Arrow / Caret_Circle_Right">
                        <path id="Vector" d="M11 9L14 12L11 15M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12Z" stroke="#0d99ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </g>
                        </svg>
                    </div>
                </div>
            </div>
        `;
    }

    success = null;
}
